import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { FileUploader } from "react-drag-drop-files";
import {
  setLoading,
  setPDForcefullyRedux,
  updateScreenPage,
  setAddressForcefullyRedux,
} from "../../../../redux";
import { validateIncomeProof } from "../IncomeProof/redux/action";
import { handleVerifyPan, handleVerifyAddress } from "./redux/action";
import { makeid, fileToBase64 } from "./../../../../utils";
import Title from "../../components/Title";
import Button from "../../components/Button";
import Webcam from "react-webcam";
import { getIsPermanentChange } from "./../PersonalData/Helpers";
import "./style.css";
import InputTitle from "designs/v1/components/InputTitle";
import { showNextBtnByUrl, getPrevAndNextRoute } from "utils";

const FACING_MODE_USER = "user";
const FACING_MODE_ENVIRONMENT = "environment";

const FILE_TYPES = ["JPG", "JPEG", "PNG", "PDF"];

const videoConstraints = {
  width: 220,
  height: 200,
  facingMode: FACING_MODE_USER,
};

const WebcamCapture = ({ handleImg, handleShow, disabled, show }) => {
  const [facingMode, setFacingMode] = useState(FACING_MODE_USER);
  const [image, setImage] = useState("");
  const webcamRef = React.useRef(null);

  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImage(imageSrc);
    handleImg(imageSrc);
  });

  const handleChangeMode = React.useCallback(() => {
    setFacingMode((prevState) =>
      prevState === FACING_MODE_USER
        ? FACING_MODE_ENVIRONMENT
        : FACING_MODE_USER
    );
  }, []);

  const handleClose = (bool) => {
    setImage("");
    handleShow(bool);
  };

  return (
    <>
      {show ? (
        <div className="webcam-container">
          <div className="webcam-img">
            {image == "" ? (
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                width={"100%"}
                videoConstraints={{
                  ...videoConstraints,
                  facingMode,
                }}
              />
            ) : (
              <img
                src={image}
                alt=""
              />
            )}
          </div>
          <div>
            {image != "" ? (
              <>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setImage("");
                  }}
                  className="btn btn-success mx-2"
                >
                  Retake Image
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleClose(false);
                  }}
                  className="btn btn-warning mx-2"
                >
                  Close
                </button>
              </>
            ) : (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    capture();
                  }}
                  className="btn btn-success"
                >
                  Capture
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleClose(false);
                  }}
                  className="btn btn-warning mx-2"
                >
                  Close
                </button>
                {isMobile && (
                  <button
                    type="button"
                    onClick={handleChangeMode}
                    className="btn btn-secondary"
                  >
                    Switch camera
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <button
          className="btn btn-warning"
          disabled={disabled}
          onClick={() => handleShow(true)}
        >
          Open Camera
        </button>
      )}
    </>
  );
};

const Address = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { isPanVerify } = useSelector((state) => state.address);
  const { pageFlow, kycStatus, kycPageName, setforcefully, panState } =
    useSelector((state) => state.navigation);
  const { inputLabelColor, inputError } = useSelector((state) => state.theme);
  const [panProof, setPanProof] = useState("");
  const [addressFrontImage, setAddressFrontImage] = useState();
  const [addressBackImage, setAddressBackImage] = useState();
  const [addressProofType, setAddressProofType] = useState("");
  const addressFrontImageRef = useRef();
  const addressBackImageRef = useRef();

  const [isDisable, setIsDisable] = useState(false);
  const [isDisable1, setIsDisable1] = useState(false);
  const [isDisable2, setIsDisable2] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [isShow1, setIsShow1] = useState(false);
  const [isShow2, setIsShow2] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [checkType, setCheckType] = useState(true);

  const getApiUrl = () => {
    const portal_domain = window.sessionStorage.getItem("portal_domain");
    let API_URL = "";
    if (portal_domain) {
      API_URL = portal_domain.substring(0, portal_domain.length - 1);
    }
    return API_URL;
  };

  // useEffect(() => {
  //   handleValidate({ addressProofType, addressFrontImage, addressBackImage });
  // }, [addressProofType, addressFrontImage, addressBackImage]);

  const handleValidate = () => {
    let isValid = true;
    if (
      !addressProofType ||
      (addressProofType === "DrivingLicense" && !addressFrontImage) ||
      (!["DrivingLicense"].includes(addressProofType) &&
        (!addressFrontImage || !addressBackImage))
    ) {
      isValid = false;
    }
    return isValid;
  };

  const setPDForcefully = () => {
    let index = 0;
    for (let i in pageFlow) {
      if (pageFlow[i] == "PersonalData") {
        index = i;
      }
    }
    dispatch(setAddressForcefullyRedux(index, false, "PersonalData"));
  };
  useEffect(() => {
    // console.log(kycStatus);
    for (let i in kycStatus) {
      if (kycStatus[i]["Address"]) {
        if (kycStatus[i]["Address"]["status"]) {
          if (panState) {
            dispatch(updateScreenPage());
          }
        }
      }
    }
  }, [kycStatus]);

  const handlePanImg = (img) => {
    uploadPanImageCapture(img);
  };

  const handleAddressFrontImg = (img) => {
    setCheckType(false);
    setAddressFrontImage(img);
  };

  const handleAddressBackImg = (img) => {
    setCheckType(false);
    setAddressBackImage(img);
  };

  const handleShow = (bool) => {
    setIsShow(bool);
  };
  const handleShow1 = (bool) => {
    setIsShow1(bool);
    setIsDisable1(bool);
  };
  const handleShow2 = (bool) => {
    setIsShow2(bool);
    setIsDisable1(bool);
  };

  const handleSubmit = async () => {
    setSubmitted(true);
    if (handleValidate()) {
      dispatch(setLoading(true));
      const formData = new FormData();
      formData.append("type", addressProofType);
      if (checkType) {
        if (addressFrontImage) {
          if (addressFrontImage.type === "application/pdf") {
            formData.append("file1", addressFrontImage, makeid(6) + ".pdf");
          } else {
            const file1 = await fileToBase64(addressFrontImage);
            formData.append("file1", file1?.split(",").pop());
          }
        }
        if (addressBackImage) {
          if (addressBackImage.type === "application/pdf") {
            formData.append("file2", addressBackImage, makeid(6) + ".pdf");
          } else {
            const file2 = await fileToBase64(addressBackImage);
            formData.append("file2", file2?.split(",").pop());
          }
        }
        if (
          (addressFrontImage && addressFrontImage.type === "application/pdf") ||
          (addressBackImage && addressBackImage.type === "application/pdf")
        ) {
          formData.append("file_type", "pdf");
        } else {
          formData.append("file_type", "Base64");
        }
      } else {
        formData.append(
          "file1",
          addressFrontImage?.replace("data:image/jpeg;base64,", "")
        );
        formData.append(
          "file2",
          addressBackImage?.replace("data:image/jpeg;base64,", "")
        );
        formData.append("file_type", "Base64");
      }
      if (getIsPermanentChange()) {
        formData.append("permanent_address_changed", getIsPermanentChange());
      }
      dispatch(handleVerifyAddress(formData));
    } else {
      toast.error("Please select address proof image.");
    }
  };

  const uploadPanImageCapture = (file) => {
    dispatch(setLoading(true));
    let formData = new FormData();
    formData.append("type", "PAN");
    formData.append("files", file?.replace("data:image/jpeg;base64,", ""));
    formData.append("file_type", "Base64");
    dispatch(handleVerifyPan(formData));
  };

  const uploadPanImage = async (file) => {
    if (file) {
      const allowed_types = ["image/png", "image/jpeg", "application/pdf"];
      if (!allowed_types.includes(file.type)) {
        toast.error("Only Images are allowed ( JPG | PNG | PDF )", "Error");
        return;
      }
      const fileSize = file.size / 1024 ** 2;
      if (fileSize >= 4) {
        toast.error("Please upload a file smaller than 4MB");
        return;
      }
      setPanProof(file);
      if (file.type === "application/pdf") {
        let isEncrypted = false;
        dispatch(setLoading(true));
        try {
          const formData = new FormData();
          formData.append("file", file, makeid(6) + ".pdf");
          const resp = await validateIncomeProof(formData);
          isEncrypted = resp.data?.message || false;
          dispatch(setLoading(false));
        } catch (error) {}
        if (isEncrypted) {
          toast.error("Please upload a file without password protected.");
          dispatch(setLoading(false));
          return;
        }
        setIsShow(false);
        dispatch(setLoading(true));
        let formData = new FormData();
        formData.append("type", "PAN");
        formData.append("files", file, makeid(6) + ".pdf");
        formData.append("file_type", "pdf");
        dispatch(handleVerifyPan(formData));
        return;
      } else {
        dispatch(setLoading(true));
        let img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onload = async () => {
          if (img.width >= 250 && img.height >= 200) {
            setIsShow(false);
            dispatch(setLoading(true));
            let formData = new FormData();
            formData.append("type", "PAN");
            formData.append("files", file, makeid(6) + ".JPEG");
            formData.append("file_type", "Image");
            dispatch(handleVerifyPan(formData));
          } else {
            return toast.error(
              `The image you uploaded is of lower resolution. Please upload a higher resolution image.`
            );
          }
        };
      }
    }
  };

  const uploadAddressFrontImg = async (thefile) => {
    if (thefile) {
      const allowed_types = ["image/png", "image/jpeg", "application/pdf"];
      if (!allowed_types.includes(thefile.type)) {
        toast.error("Only Images are allowed ( JPG | PNG | PDF )", "Error");
        return;
      }
      const fileSize = thefile.size / 1024 ** 2;
      if (fileSize >= 4) {
        toast.error("Please upload a file smaller than 4MB");
        return;
      }
      if (thefile.type === "application/pdf") {
        let isEncrypted = false;
        dispatch(setLoading(true));
        try {
          const formData = new FormData();
          formData.append("file", thefile, makeid(6) + ".pdf");
          const resp = await validateIncomeProof(formData);
          isEncrypted = resp.data?.message || false;
          dispatch(setLoading(false));
        } catch (error) {}
        if (isEncrypted) {
          toast.error("Please upload a file without password.");
          dispatch(setLoading(false));
          return;
        }
        setAddressFrontImage(thefile);
        setCheckType(true);
        setIsDisable2(true);
      } else {
        let img = new Image();
        img.src = window.URL.createObjectURL(thefile);
        img.onload = async () => {
          if (img.width >= 250 && img.height >= 200) {
            setAddressFrontImage(thefile);
            setCheckType(true);
            setIsDisable2(true);
          } else {
            return toast.error(
              `The image you uploaded is of lower resolution. Please upload a higher resolution image.`
            );
          }
        };
      }
    }
  };

  const uploadAddressBackImg = async (thefile) => {
    if (thefile) {
      const allowed_types = ["image/png", "image/jpeg", "application/pdf"];
      if (!allowed_types.includes(thefile.type)) {
        toast.error("Only Images are allowed ( JPG | PNG | PDF )", "Error");
        return;
      }
      const fileSize = thefile.size / 1024 ** 2;
      if (fileSize >= 4) {
        toast.error("Please upload a file smaller than 4MB");
        return;
      }
      if (thefile.type === "application/pdf") {
        let isEncrypted = false;
        dispatch(setLoading(true));
        try {
          const formData = new FormData();
          formData.append("file", thefile, makeid(6) + ".pdf");
          const resp = await validateIncomeProof(formData);
          isEncrypted = resp.data?.message || false;
          dispatch(setLoading(false));
        } catch (error) {}
        if (isEncrypted) {
          toast.error("Please upload a file without password.");
          dispatch(setLoading(false));
          return;
        }
        setAddressBackImage(thefile);
        setCheckType(true);
        setIsDisable2(true);
      } else {
        let img = new Image();
        img.src = window.URL.createObjectURL(thefile);
        img.onload = async () => {
          if (img.width >= 250 && img.height >= 200) {
            setAddressBackImage(thefile);
            setCheckType(true);
            setIsDisable2(true);
          } else {
            return toast.error(
              `The image you uploaded is of lower resolution. Please upload a higher resolution image.`
            );
          }
        };
      }
    }
  };

  const handleAddressType = (event) => {
    setAddressProofType(event.target.value ?? "");
    setAddressFrontImage("");
    setAddressBackImage("");
    if (addressFrontImageRef.current) {
      addressFrontImageRef.current.value = "";
    }
    if (addressBackImageRef.current) {
      addressBackImageRef.current.value = "";
    }
  };

  return (
    <React.Fragment>
      <div className="wrapper_login get-started-btn">
        <div className="form_wrapper">
          <div className="col-md-12 mb-4">
            <Title title="Identification & Address Document Upload" />
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-12">
                    <InputTitle
                      title={"Upload your PAN image (jpg, png, pdf)"}
                      className="mb-1"
                    />
                  </div>
                  {/* <div className="col-md-6" style={{textAlign:"right"}}>
                      
                    </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                {isPanVerify ? (
                  "Pan uploaded"
                ) : (
                  <>
                    <div className="file-uploader-container">
                      <FileUploader
                        handleChange={(file) => uploadPanImage(file)}
                        name="file"
                        types={FILE_TYPES}
                        disabled={isDisable}
                      />
                    </div>
                    {panProof?.name && (
                      <p>
                        <small>File name: {panProof.name}</small>
                      </p>
                    )}
                    <div>
                      <label className="my-1 text-muted text-sm">
                        <small>
                          {!isPanVerify && "Maximum file size: 4 MB"}
                        </small>
                      </label>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="col-md-6">
              {!isPanVerify && (
                <div style={{ position: "relative" }}>
                  <WebcamCapture
                    handleImg={handlePanImg}
                    handleShow={handleShow}
                    show={isShow}
                    disabled={isDisable}
                  />
                </div>
              )}
            </div>
          </div>
          {isPanVerify && (
            <>
              <div className="row">
                <div className="col-md-6 mt-2">
                  <InputTitle
                    className="mb-1"
                    title={"Upload your address proof"}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <select
                    onChange={handleAddressType}
                    className={
                      "form-select" +
                      (submitted && !addressProofType ? " is-invalid" : "")
                    }
                  >
                    <option value="">--Select--</option>
                    <option value="Aadhaar">Aadhaar</option>
                    <option value="Passport">Passport</option>
                    {getApiUrl() != "https://scmcbrke.in" && (
                      <>
                        <option value="DrivingLicense">Driving Licence</option>
                        <option value="VoterID">Voter Id</option>
                      </>
                    )}
                  </select>
                  {submitted && !addressProofType && (
                    <div style={{ color: inputError }}>
                      Please select an option
                    </div>
                  )}
                </div>
              </div>

              {addressProofType && (
                <>
                  <div className="row d-flex align-items-center">
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="row">
                          <div className="col-md-12">
                            <InputTitle
                              title={`Front Image (jpg, png, pdf)`}
                              isRequired={true}
                              className={"my-1"}
                            />
                          </div>
                        </div>
                        <div className="file-uploader-container">
                          <FileUploader
                            handleChange={(file) => uploadAddressFrontImg(file)}
                            name="file"
                            types={FILE_TYPES}
                            disabled={isDisable1}
                            ref={addressFrontImageRef}
                          />
                        </div>
                        {addressFrontImage?.name && (
                          <p>
                            <small>File name: {addressFrontImage.name}</small>
                          </p>
                        )}
                        {/* <input
                          type="file"
                          accept="image/*,application/pdf"
                          className="form-control"
                          onChange={uploadAddressFrontImg}
                          disabled={isDisable1}
                          ref={addressFrontImageRef}
                        /> */}
                      </div>
                    </div>
                    <div className="col-md-6 mt-4">
                      <WebcamCapture
                        handleImg={handleAddressFrontImg}
                        handleShow={handleShow1}
                        show={isShow1}
                        disabled={isDisable2}
                      />
                    </div>
                  </div>

                  <div className="row d-flex align-items-center">
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="row">
                          <div className="col-md-12">
                            <InputTitle
                              title={`Back Image (jpg, png, pdf)`}
                              isRequired={addressProofType !== "DrivingLicense"}
                              className={"my-1"}
                            />
                          </div>
                        </div>
                        <div className="file-uploader-container">
                          <FileUploader
                            handleChange={(file) => uploadAddressBackImg(file)}
                            name="file"
                            types={FILE_TYPES}
                            disabled={isDisable1}
                            ref={addressBackImageRef}
                          />
                        </div>
                        {addressBackImage?.name && (
                          <p>
                            <small>File name: {addressBackImage.name}</small>
                          </p>
                        )}
                        {/* <input
                          type="file"
                          accept="image/*,application/pdf"
                          className="form-control"
                          onChange={uploadAddressBackImg}
                          disabled={isDisable1}
                          ref={addressBackImageRef}
                        /> */}
                      </div>
                    </div>
                    <div className="col-md-6 mt-4">
                      <WebcamCapture
                        handleImg={handleAddressBackImg}
                        handleShow={handleShow2}
                        show={isShow2}
                        disabled={isDisable2}
                      />
                    </div>
                  </div>
                </>
              )}
            </>
          )}
          <div>
            <label className="my-1 text-muted text-sm">
              <small>{isPanVerify && "Maximum file size: 4 MB"}</small>
            </label>
          </div>
          <div className="col-md-12 mt-3">
            {isPanVerify && (
              <div className="d-flex">
                <Button
                  title="Submit"
                  type="button"
                  className="Submit mx-1"
                  handleClick={handleSubmit}
                />
                {showNextBtnByUrl(
                  history.location.pathname,
                  kycStatus,
                  kycPageName
                ) && (
                  <Button
                    title="Next"
                    type="button"
                    className="mx-1"
                    handleClick={() => {
                      const route = getPrevAndNextRoute(
                        history.location.pathname.slice(1),
                        kycPageName
                      );
                      history.push(route.next);
                    }}
                  />
                )}
              </div>
            )}
            {setforcefully && (
              <button
                className="btn btn-light"
                type="button"
                onClick={() => {
                  let index = 0;
                  for (let i in pageFlow) {
                    if (pageFlow[i] == "PersonalData") {
                      index = i;
                    }
                  }
                  dispatch(setPDForcefullyRedux(index));
                }}
              >
                Go Back
              </button>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Address;
